export default class PreHandlerResult {

    constructor(breakVal = false, handled = false) {
        this.break = breakVal
        this.handled = handled
    }

}
